import {OptionStatusIndicator} from 'platform/components';

import {QualitySealResponseBody} from '@dms/api/sales';
import i18n from '@dms/i18n';

import {Nullish} from 'shared/web';

type QualitySealOption = {
  value: string;
  label: string;
  statusIndicator?: OptionStatusIndicator;
};

type BuildQualitySealOptionsParams = {
  activeSeals: QualitySealResponseBody[];
  selectedSeal: QualitySealResponseBody | Nullish;
};

export function buildQualitySealOptions(
  params: BuildQualitySealOptionsParams
): QualitySealOption[] {
  const activeOptions = params.activeSeals.map(({key, displayName}) => ({
    value: key,
    label: displayName,
  }));

  if (
    params.selectedSeal == null ||
    params.selectedSeal.status !== 'DISCONTINUED' ||
    params.activeSeals.some(({key}) => key === params.selectedSeal?.key)
  ) {
    return activeOptions;
  }

  return [
    ...activeOptions,
    {
      value: params.selectedSeal.key,
      label: params.selectedSeal.displayName,
      statusIndicator: {tooltip: i18n.t('entity.qualitySeal.labels.discontinued')},
    },
  ];
}
